
import { Vue, Component } from 'vue-property-decorator'
import { apiStorageList, apiStorageChange } from '@/api/setting'
@Component({
    components: {}
})
export default class StorageIndex extends Vue {
    /** S Data **/
    list = []
    oldEngine = 'local' // 默認引擎
    /** E Data **/

    /** S Methods **/
    // 跳转引擎設置頁面
    onStorageEdit(item: any) {
        this.$router.push({
            path: '/setting/storage/storage',
            query: {
                engine: item.engine // 存储引擎
            }
        })
    }

    // 獲取存储引擎列表
    getStorageList() {
        apiStorageList()
            .then((res: any) => {
                this.list = res
                console.log(res)
                // this.$message.success("刪除成功!");
            })
            .catch(() => {
                this.$message.error('獲取數據失敗，請重試！')
            })
    }
    // 切换引擎
    postStorageChange(item: any) {
        apiStorageChange({ engine: item.engine })
            .then((res: any) => {
                this.getStorageList()
                this.$message.success('更新成功')
            })
            .catch(() => {
                this.$message.error('更新失敗')
            })
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.getStorageList()
    }
    /** E Life Cycle **/
}
